import { jsx as o, jsxs as m } from "react/jsx-runtime";
import { Root as g, Slottable as h } from "@radix-ui/react-slot";
import { cva as e } from "class-variance-authority";
import { forwardRef as x } from "react";
import { cn as r } from "./index.es14.js";
const v = e(
  "p-3 flex items-center justify-center rounded-capsule outline-offset-2 focus:outline-blue-600 hover:cursor-pointer",
  {
    variants: {
      variant: {
        secondary: "bg-gray-800 hover:bg-gray-900 text-gray-200",
        transparent: "bg-transparent text-gray-900"
      },
      size: {
        small: "h-[32px] w-[32px] p-2.5",
        default: "h-[40px] w-[40px]",
        large: "h-[56px] w-[56px]"
      },
      disabled: {
        true: "bg-gray-200 text-gray-500 focus:outline-none hover:bg-gray-200 hover:text-gray-500 hover:cursor-not-allowed"
      }
    }
  }
), b = e("fill-current hover:fill-current", {
  variants: {
    size: {
      small: "w-3 h-3",
      default: "w-4 h-4",
      large: "w-4 h-4"
    }
  }
}), R = x(
  ({
    className: a = "",
    children: n,
    variant: s = "secondary",
    size: t = "default",
    disabled: l = !1,
    icon: c,
    asChild: i,
    ...u
  }, p) => {
    const d = r(v({ variant: s, size: t, disabled: l }), a), f = /* @__PURE__ */ o("div", { "data-testid": "icon-button-icon-container", className: r(b({ size: t })), children: c });
    return /* @__PURE__ */ m(i ? g : "button", { "data-testid": "icon-button", title: "Icon button", className: d, ...u, ref: p, children: [
      /* @__PURE__ */ o(h, { children: n }),
      f
    ] });
  }
);
export {
  R as IconButton
};
